import Checkbox, { CheckboxProps } from './Checkbox'

const Toggle = (props: Omit<CheckboxProps, 'toggle'>) => (
  <Checkbox toggle {...props} />
)

export default Toggle
